import first from 'lodash/first'
import map from 'lodash/map'
import React, { FC, useMemo } from 'react'

import { ImageData, ImageGrid } from '@Components/CMS/ImageGrid'
import { Block, ImageResource } from '@Generated/graphql'
import {
  getJSONFieldValue,
  getLinkFieldValue,
  getLinkType,
  getReferenceFieldValue,
} from '@Globals/CMS/FieldHelpers'
import { Image } from '@Globals/Image'

interface ImageGridBlockData {
  images: ImageData[]
  round: boolean
}

const getBlockData = (imageGridBlock: Block): ImageGridBlockData => {
  const images = getReferenceFieldValue<ImageResource>(imageGridBlock.fields || [], 'images') || []

  return {
    images: map(images, (x) => {
      const link = getLinkFieldValue(x.fields || [], 'link')

      const image: Image = {
        dimensions: {
          height: x?.image?.dimensions?.height || 0,
          width: x?.image?.dimensions?.width || 0,
        },
        url: x?.image?.url || '',
      }

      const reference = first(link?.references)
      const referenceID = reference && 'id' in reference ? reference.id || '' : ''

      return {
        caption: x.captionOptions?.caption || '',
        destPageType: link ? getLinkType(link) : '',
        destPageTypeId: referenceID,
        image,
        link: link?.url || '',
        linkNewTab: link?.newTab || false,
      }
    }),
    round: getJSONFieldValue(imageGridBlock.fields || [], 'roundImages') || false,
  }
}

interface ImageGridBlockProps {
  id?: string
  imageGridBlock: Block
}

const ImageGridBlock: FC<ImageGridBlockProps> = ({ id, imageGridBlock }) => {
  const { images, round } = useMemo(() => getBlockData(imageGridBlock), [imageGridBlock])

  return (
    <ImageGrid
      id={id}
      images={images}
      round={round}
    />
  )
}

export default ImageGridBlock
